import { from, of } from "rxjs";
import { ofType, combineEpics } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { loadAllManagementGroupsActionTypes, loadedAllManagementGroupsAction, loadingAllManagementGroupsAction } from "./ManagementGroupSelector.ducks.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
const getAllManagementGroupsEpic = (action$) => {
  return action$.pipe(
    ofType(loadAllManagementGroupsActionTypes.LOAD),
    mergeMap((v) => {
      const workspaceId = EnvironmentService.getWorkspaceIdOrDefault(v == null ? void 0 : v.workspaceId);
      const getAllManagementGroups = from(MdsDataplaneResources.getPaths(workspaceId)).pipe(
        mergeMap((r) => {
          return of(
            loadedAllManagementGroupsAction({
              data: r,
              error: "",
              isLoading: false
            })
          );
        })
      );
      const act = loadingAllManagementGroupsAction();
      return from([getAllManagementGroups, from([act])]).pipe(mergeMap((x) => x));
    })
  );
};
const ManagementGroupSelector_epics = combineEpics(getAllManagementGroupsEpic);
export {
  ManagementGroupSelector_epics as default,
  getAllManagementGroupsEpic
};
//# sourceMappingURL=ManagementGroupSelector.epics.js.map
